<template>
  <div class="building-created-chart">
    <apexchart type="bar" :options="options" :series="series"></apexchart>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import axios from 'axios'
import { userStore } from '@/stores/userStore'

export default {
  name: 'BuildingsCreatedChart',
  components: {},
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  inject: {
    userStore,
  },
  data: function () {
    return {
      options: {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 4,
          colors: ['transparent'],
        },
        xaxis: {
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
        },
        yaxis: {
          title: {
            text: '# of Buildings Priced',
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return '# priced ' + val
            },
          },
        },
      },
    }
  },
  methods: {},
  mounted() {},
  computed: {
    // todo: allow switching this to other views like by value, or unique customers
    // todo can we show sales per user and put on tooltip??
    // todo PPULL IN STAST FROM EMAIL LEADS
    // todo: COLORS
    // TODO: ALLLOW TOGGLINGS SALES VS ORDER DATES ON CALENDAR
    series() {
      let months = [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
      ]

      let dates2022 = _.filter(this.data, b => {
        return b.date.match('2022')
      })
      let sorted2022 = _.sortBy(dates2022, ['date'])
      let dates2023 = _.filter(this.data, b => {
        return b.date.match('2023')
      })
      let sorted2023 = _.sortBy(dates2023, ['date'])

      return [
        {
          name: '2022',
          data: months.map(m => {
            let record = sorted2022.find(sd => {
              return sd.date.match(m)
            })
            if (record) {
              return record.count
            } else {
              return 0
            }
          }),
        },
        {
          name: '2023',
          data: months.map(m => {
            let record = sorted2023.find(sd => {
              return sd.date.match(m)
            })
            if (record) {
              return record.count
            } else {
              return 0
            }
          }),
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped></style>
